import { Img } from "ui-kit/components-branded/index"
import { randomize } from "utils/helpers"

const greetings = [
    <>здравствуйте!</>,
    <>рады видеть вас!</>,
    <>вы сегодня прекрасны!</>,
    <>как настроение сегодня?</>,
    <>добро пожаловать в&nbsp;свой внутренний мир!</>,
    <>здесь начинается новая жизнь</>,
]
const greeting = randomize(greetings)

export function HelloHeaderRandomGreeting(props: { name: string }) {
    return (
        <div className="is-flex is-align-items-flex-start hello-header__wrapper">
            <Img src="greeting-icon.png" className="hello-header__icon" />
            <span className="hello-header__greeting">
                {props.name}, {greeting}
            </span>
        </div>
    )
}
